// extracted by mini-css-extract-plugin
export default {"name":"TicketCard_name__pyevq","ticketNumber":"TicketCard_ticketNumber__p+WKk","price":"TicketCard_price__uSM2T"};